import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { addToast } from '../../Slice/ToastSlice';
import { AppDispatch } from '../../Store';

interface CopyItem {
  value: string;
  label: string;
}

interface ThisProps {
  textToCopy: CopyItem[];
  textToDisplay: string;
}

/**
 * @author noone
 */
const ChooseCopyComponent: React.FC<ThisProps> = (props) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const dispatch = useDispatch<AppDispatch>();

  const copyItem = async (item: CopyItem) => {
    try {
      if (!navigator.clipboard || !window.isSecureContext) {
        throw new Error('Die Zwischenablage ist in diesem Kontext nicht verfügbar.');
      }

      await navigator.clipboard.writeText(item.value);
      dispatch(addToast({
        message: `${item.label} wurde in die Zwischenablage kopiert.`,
        durationSeconds: 5,
      }));
    } catch (error) {
      console.error("Fehler beim Kopieren:", error);
    }
  };

  return (
    <div style={{ width: '100%', textAlign: 'center', marginTop: '10px' }}>
      <button
        className="btn btn-light"
        type="button"
        aria-expanded={isExpanded}
        style={{ width: '100%', textAlign: 'center' }}
        onClick={() => setIsExpanded((expanded) => !expanded)}
        disabled={props.textToCopy.length === 0}
      >
        <i className="bi bi-copy"></i> {props.textToDisplay}
      </button>
      {isExpanded && (
        <div className="list-group mt-2">
          {props.textToCopy.map((item, index) => (
            <div
              className="list-group-item d-flex justify-content-between align-items-center"
              key={`${item.label}-${index}`}
            >
              <span>{item.label}</span>
              <span style={{fontSize: '0.5em', color: 'gray'}}>{item.value}</span>
              <button
                className="btn btn-sm btn-outline-secondary"
                type="button"
                aria-label={`Kopiere ${item.label}`}
                onClick={() => {
                  void copyItem(item);
                  setIsExpanded(false);
                }}
              >
                <i className="bi bi-copy"></i> Kopieren
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );

}

export default ChooseCopyComponent;